import { Link } from 'react-router-dom';
import { getLatestComics, type Comic } from '@/mocks/comics';

function LatestCard({ comic }: { comic: Comic }) {
  return (
    <Link to={`/comic/${comic.id}`} className="group flex gap-4 p-3 rounded-lg hover:bg-background-100 transition-colors" data-product-shop>
      <div className="w-20 h-[110px] flex-shrink-0 overflow-hidden rounded-md bg-background-200">
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 最新章节免费在线阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col justify-between py-1">
        <div>
          <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
            {comic.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        </div>
        <div>
          <div className="flex items-center gap-1 mb-1">
            {comic.tags.slice(0, 2).map((tag) => (
              <span key={tag} className="px-1.5 py-0.5 bg-accent-100 text-accent-700 text-[10px] rounded">
                {tag}
              </span>
            ))}
          </div>
          <div className="flex items-center justify-between">
            <span className="text-[11px] text-foreground-400">更新至 {comic.chapters[comic.chapters.length - 1].title}</span>
            <span className="text-[11px] text-foreground-400">{comic.updateTime}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default function LatestUpdates() {
  const latestComics = getLatestComics(8);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">每日更新，追更不等待</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {latestComics.map((comic) => (
            <LatestCard key={comic.id} comic={comic} />
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/category/rexue"
            className="inline-flex items-center gap-1 px-6 py-2.5 border border-primary-300 text-primary-600 rounded-full text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            查看更多更新
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}